import { useCallback, useLayoutEffect, useRef } from "react";
// src/hooks/useStableCallback.ts
/**
* A callback with a stable identity that always sees the latest render's values.
*
* - Not `useEffectEvent`: that one must not be passed to other components.
* - Updated in a layout effect, so it lands before paint and input.
* - A child's layout effect calling it still sees the previous render's closure.
*/
const useStableCallback = (callback) => {
	const latestRef = useRef(callback);
	useLayoutEffect(() => {
		latestRef.current = callback;
	}, [callback]);
	return useCallback((...args) => latestRef.current(...args), []);
};
export { useStableCallback };

//# sourceMappingURL=useStableCallback.js.map